import { render, staticRenderFns } from "./pharmacy-detail-page.vue?vue&type=template&id=18d88c4c&scoped=true"
import script from "./pharmacy-detail-page.vue?vue&type=script&lang=js"
export * from "./pharmacy-detail-page.vue?vue&type=script&lang=js"
import style0 from "./pharmacy-detail-page.vue?vue&type=style&index=0&id=18d88c4c&prod&lang=scss&scoped=true"
import style1 from "./pharmacy-detail-page.vue?vue&type=style&index=1&id=18d88c4c&prod&scoped=true&lang=css"
import style2 from "./pharmacy-detail-page.vue?vue&type=style&index=2&id=18d88c4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d88c4c",
  null
  
)

export default component.exports